<template>
  <div>
    <div class="radius wow slideInLeft" data-wow-duration="1s" data-wow-delay=".5s"></div>
    <div class="adv_s">
      <div class="content">

        <a href="https://smis.cn/smiswebuser/#/">
          <div class="apply_btn wow bounceInLeft" data-wow-duration="1s" data-wow-delay=".5s">
            免费使用
          </div>
        </a>

      </div>
      <div
        style="height: 180px;margin: auto auto auto 120px;display: flex;align-items: center;position: absolute;bottom: 10px;">
        <div style="width: 580px;height: 180px;background: rgb(255, 255, 255);display: flex;align-items: center;">
          <img src="../../assets/bg_item1.png" style="    width: 152px;height: 152px;margin-left: 45px;">
          <div style="margin-left: 34px;">
            <div style="font-size: 20px; color: rgb(0, 0, 0); font-weight: bold;">拾脉（smis）智慧医养信息系统</div>
            <div style="font-size: 16px; color: rgb(166, 164, 164); margin-top: 7px;">平台v3.0.0版本</div>
            <a href="https://smis.cn/smiswebuser/#/">
              <div
                style="cursor: pointer; margin-top: 20px; font-size: 16px; height: 40px; width: 130px; text-align: center; line-height: 40px; background: rgb(235, 92, 1); color: rgb(255, 255, 255); border-radius: 4px;">
                免费使用
              </div>
            </a>
          </div>
        </div>
        <div
          style="width: 580px;height: 180px;background: rgb(255, 255, 255);display: flex;align-items: center;margin-left: 10px">
          <img src="../../assets/bg_item2.png" style="    width: 152px;height: 152px;margin-left: 45px;">
          <div style="margin-left: 34px;">
            <div style="font-size: 20px; color: rgb(0, 0, 0); font-weight: bold;">拾脉（swis）智慧病房信息系统</div>
            <div style="font-size: 16px; color: rgb(166, 164, 164); margin-top: 7px;">平台v1.0.0版本</div>
            <a href="https://smis.cn/smiswebuser/#/">
              <div
                style="cursor: pointer; margin-top: 20px; font-size: 16px; height: 40px; width: 130px; text-align: center; line-height: 40px; background: rgb(235, 92, 1); color: rgb(255, 255, 255); border-radius: 4px;">
                免费使用
              </div>
            </a>
          </div>
        </div>
        <div
          style="width: 580px;height: 180px;background: rgb(255, 255, 255);display: flex;align-items: center;margin-left: 10px">
          <img src="../../assets/bg_item3.png" style="    width: 152px;height: 152px;margin-left: 45px;">
          <div style="margin-left: 34px;">
            <div style="font-size: 20px; color: rgb(0, 0, 0); font-weight: bold;">拾脉（smis）智慧社区信息系统</div>
            <div style="font-size: 16px; color: rgb(166, 164, 164); margin-top: 7px;">平台v1.0.0版本</div>
            <a href="https://smis.cn/smiswebuser/#/">
              <div
                style="cursor: pointer; margin-top: 20px; font-size: 16px; height: 40px; width: 130px; text-align: center; line-height: 40px; background: rgb(235, 92, 1); color: rgb(255, 255, 255); border-radius: 4px;">
                免费使用
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>
    <div class="feature_wrap">
      <div class="center_content">
        <div class="words">
          <p class="w1">健康是生命最好的状态</p>
          <p class="w2">Health Is The Best Condition Of Life</p>
          <p class="w3">至 极 至 简&nbsp;&nbsp;&nbsp;&nbsp;
            至 臻 至 美&nbsp;&nbsp;&nbsp;&nbsp;
            云 端 科 技&nbsp;&nbsp;&nbsp;&nbsp;
            处 智 有 方
          </p>
        </div>

        <div class="feature">
          <Row type="flex" justify="space-around">
            <Col span="7" class="feature_item wow bounceInUp" data-wow-duration="1s" data-wow-delay="0s"
              data-wow-offset="200">
            <div>
              <p>
                <img src="/static/img/msg.png" alt="">
              </p>
              <p>实时传递，信息互通。</p>
              <p>用最快捷的方式，传递最新信息。</p>
            </div>
            </Col>
            <Col span="7" class="feature_item wow bounceInUp" data-wow-duration="1s" data-wow-delay=".5s"
              data-wow-offset="200">
            <div>
              <p>
                <img src="/static/img/cloud_ico.png" alt="">
              </p>
              <p>
                云有端，处有方。
              </p>
              <p>
                拥有专属云端，实现便捷管理
              </p>
            </div>
            </Col>
            <Col span="7" class="feature_item wow bounceInUp" data-wow-duration="1s" data-wow-delay="1s"
              data-wow-offset="200">
            <div>
              <p>
                <img src="/static/img/pc.png" alt="">
              </p>
              <p>
                时刻监测，守护健康。
              </p>
              <p>
                随时随地，一键获取，健康在握
              </p>
            </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <div class="intro_wrap">
      <div class="corporation_intro">
        <div class="main_info wow fadeInLeft" data-wow-duration=".4s" data-wow-offset="400">
          <p>云处方·云端科技 处智有方</p>
          <p></p>
          <p class="companyProfile">
            致力于大健康产业互联网、物联网底层技术研究和开发的高科技互联网公司，地处国家“双创”产业示范基地——四川成都郫都区菁蓉镇。产品创意来源于成都市政府举办的成都“创意设计周”创意大赛的获奖（银奖）项目，其理念是：以长者为中心，以病床为平台，通过互联网、物联网和微信号智能感知采集等技术，拓展医养的视野，建立家庭病房，并以此为基础，融合第三方服务而打造的开放性的大健康平台。
          </p>
          <Button class="learn_more" type="error" ghost :to="{ path: '/About', query: {} }">了解更多</Button>
        </div>
        <div class="Carousel_wrap wow fadeIn" data-wow-offset="400" data-wow-delay=".3s">
          <Carousel v-bind:array="corporation_imgs"></Carousel>
        </div>
      </div>
    </div>
    <div class="pros_wrap">
      <div class="pros">
        <Row>
          <Col span="20">

          <div class="pros_items_wrap">
            <div v-for="(item, index) in proList" :key="index" class="item wow bounceInUp" data-wow-offset="400">
              <div class="img_wrap">
                <img :src="baseUrl + item.ImagePath" alt="">
              </div>
              <div class="desc">{{ item.Name }}</div>
            </div>
          </div>
          </Col>
          <Col span="4">
          <div class="more_pros wow fadeIn" data-wow-offset="300">
            <p>至极至简·至臻至美</p>
            <p>云处方人希望把产品和服务做到极致，而用户的使用和体验又极其简单和美好，用心极致是为了使用简单，体验美好是因为产品的臻美。</p>
            <Button class="learn_more" type="error" ghost :to="{ path: '/Pros', query: {} }">浏览更多产品</Button>
          </div>
          </Col>
        </Row>
      </div>
    </div>
    <div class="case_wrap">
      <div class="cases">
        <div class="case_images_wrap">
          <Carousel v-bind:array="corporation_imgs" v-bind:height="car_height"></Carousel>
        </div>
        <div class="case_desc">
          <p>品牌介绍</p>
          <p>一分耕耘一分收获，在云处方科技家人们的不懈努力、协同奋进下，再一次迎来喜讯。成功授予蜀国鹃都为云处方智慧医养示范基地。经过甲乙双方的高层多次接触与深层次沟通，一致决定将蜀国鹃都设立为云处方智慧医养示范基地。
            蜀国鹃都地处郫筒镇太平村，占地4300余亩，是现代生态城市人文风情养生养老国际社区，该社区约2000张智慧养老床位，社区环境优美、设备齐全、管理体制健全、运营成熟并设立多种老人休闲娱乐项目以便丰富老人日常生活。它是集社区养老、医疗保健、老年文化娱乐、游憩度假为一体的综合性花园式社区。
          </p>
          <Button class="learn_more" type="default" ghost :to="{ path: '/Pros', query: {} }">了解更多-></Button>
        </div>
      </div>
    </div>
    <div class="news_wrap">
      <div class="news">
        <div class="news_title">
          <img src="/static/img/news.png" alt="">
        </div>
        <p class="slogan">
          劳动创建世界，精神创建文明，云上共建未来，科技引领天下。
        </p>
        <div class="news_item_wrap">
          <ul class="newsUl">

            <li v-for="(item, index) in newsList" :key="index" class="animated">
              <div class="item">
                <div class="item_img">
                  <img :src="baseUrl + item.ImgPath" alt="">
                </div>
                <p class="item_title">{{ item.Title }}</p>
                <span class="sep"></span>
                <p class="content">{{ item.Title }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="kefu">
      <!-- <img src="/static/img/kefu.png" alt=""> -->
    </div>
  </div>
</template>

<script>
import Carousel from '../../components/Carousel _style1.vue'
import { WOW } from 'wowjs'
import http from '../../http'
export default {
  data() {
    return {
      msg: 'abcd....',
      car_height: 500,
      corporation_imgs: [
        {
          path: '/static/img/tu1.png',
          profile: '1',
        },
        {
          path: '/static/img/tu1.png',
          profile: '2',
        },
        {
          path: '/static/img/tu1.png',
          profile: '3',
        },
        {
          path: '/static/img/tu1.png',
          profile: '4',
        },
      ],
      //商品列表
      proList: [],
      //新闻列表
      newsList: [],
    }
  },
  components: { Carousel },
  created: function () {
    this.getProList()
    this.getNewsList()
  },
  mounted: function () {
    var wow = new WOW({ live: false })
    wow.init()
  },
  methods: {
    getNewsList: function () {
      var _this = this
      http({
        method: 'GET',
        url: '/api/NewsCenter?InstitutionID=null&mType=0&PageSize=6&Page=1',
      }).then(
        (res) => {
          // 200响应
          console.log(res)
          if (res.errorCode == '0') {
            _this.newsList = res.data.NewsCenter
          }
        },
        (err) => {
          // 500响应
          console.log(err)
        }
      )
    },
    /**
     * 获取商品列表
     */
    getProList: function () {
      var _this = this
      var data = {
        Name: 0,
        PageSize: 6,
        Page: 1,
      }
      http({
        method: 'GET',
        url: '/api/Product',
        params: data,
      }).then(
        (res) => {
          // 200响应
          console.log(res)
          if (res.errorCode == '0') {
            _this.proList = res.data.Product
          }
        },
        (err) => {
          // 500响应
          console.log(err)
        }
      )
    },
  },
}
</script>

<style scoped>
@import './index.css';

.kefu {
  position: fixed;
  right: 2px;
  top: 180px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue